import React from 'react';
import { connect } from 'react-redux';
import SpinWheelForm from './SpinningWheelForm';
import { Container } from 'reactstrap';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class SpinningWheelDetail extends React.Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('spinning_wheel_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <Container>
        <SpinWheelForm
          title="Detail Spinning Wheel"
          {...this.props}
          edit
          validateScopeOnSubmit
        />
      </Container>
    )
  }
}

const mapStateToProps=({auth:{ isFetch, isLogged, roles, id, email }})=>({
  guardData: { isFetch, isLogged, roles, id, email }
})
const enhance = connect(mapStateToProps);
export default enhance(privateView(SpinningWheelDetail));